import { createContext } from "react";
import PublicCongress from "../../../dtos/congress";
import { PublicLc } from "../../../dtos/lc";

const CongressesContext = createContext({
  lcs: [] as PublicLc[],
  congresses: [] as PublicCongress[],
});

export default CongressesContext;
